<ng-template #legacyLayout>
    <ng-template #nativeInput>
        <div class="currency-input">
            <img
                    (click)="input.focus()"
                    *ngIf="showSymbol && (currency === 'usd' || currency === 'cad')"
                    src="/assets/images/payhoa/other/dollar.svg"
            />
            <!-- suppress HtmlUnknownAttribute -->
            <input
                #input
                (blur)="setValueFromDisplay($event.target.value); blurred.emit(true)"
                (focus)="$event.target.select()"
                (keydown.enter)="input.blur(); enterPressed.emit()"
                [(ngModel)]="displayAmount"
                [attr.required]="required"
                [class.dollar-padding]="showSymbol && (currency === 'usd' || currency === 'cad')"
                [class.error]="error"
                [class.form-control-sm]="!showSymbol"
                [class.no-money-padding]="!showSymbol"
                [disabled]="disabled"
                [readonly]="readonly"
                class="form-control form-control-sm"
                [attr.name]="name"
                placeholder="{{ placeholder }}"
                type="text"
            />
        </div>
    </ng-template>

    <ng-container *ngIf="formGroup; else nativeInput">
        <ng-container [formGroup]="formGroup">
            <div class="currency-input">
                <img *ngIf="showSymbol && (currency === 'usd' || currency === 'cad')"
                     src="/assets/images/payhoa/other/dollar.svg"
                     [style.top.px]="10"
                     (click)="input.focus()" />
                <input #input
                       class="form-control form-control-sm"
                       mask="separator.2"
                       thousandSeparator=","
                       type="text"
                       (blur)="blurred.emit(true)"
                       [allowNegativeNumbers]="negativeAmounts"
                       [formControlName]="controlName"
                       [class.dollar-padding]="showSymbol && (currency === 'usd' || currency === 'cad')"
                       [class.form-control-sm]="!showSymbol"
                       [class.no-money-padding]="!showSymbol"
                       [placeholder]="placeholder">
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-container *ngIf="v2FormGroup && v2Control; else legacyLayout">
    <ng-container [formGroup]="v2FormGroup">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" readonlyField>
            <mat-icon [svgIcon]="'icon-v2:dollar'" matPrefix></mat-icon>
            <ng-container *ngIf="!isReadonly; else readonlyDisplay">
                <input type="text"
                       matInput
                       mask="separator.2"
                       thousandSeparator=","
                       [allowNegativeNumbers]="negativeAmounts"
                       [formControlName]="v2Control"
                       [placeholder]="placeholder"
                       [attr.aria-label]="'Select amount'">
            </ng-container>
            <ng-template #readonlyDisplay>
                <input matInput [value]="formatDisplayCurrency(v2FormGroup.controls[v2Control].value) || placeholder" readonly>
            </ng-template>
        </mat-form-field>
        <ng-content select="[subscriptLabel]"></ng-content>
    </ng-container>
</ng-container>
